import React, { useState, useEffect } from 'react';

const HeaderMenuContext = React.createContext({});

export default HeaderMenuContext;

export const HeaderMenuContextOverlay = ({ children, ...otherProps }) => {
  const [openedMobileMenuInfo, setOpenedMobileMenuInfo] = useState(null);
  const [navigationMenuUrls, setNavigationMenuUrls] = useState(null);
  const { location } = otherProps;

  useEffect(() => {
    if (!location?.state?.redirectedFromHeaderMenu) {
      const index = navigationMenuUrls?.findIndex(urls => urls?.includes(location.pathname));
      setOpenedMobileMenuInfo({
        ...openedMobileMenuInfo,
        menuIndex: index >= 0 ? index : null,
      });
    }
  }, [location, navigationMenuUrls]);

  return (
    <HeaderMenuContext.Provider
      value={{
        openedMobileMenuInfo,
        setOpenedMobileMenuInfo,
        navigationMenuUrls,
        setNavigationMenuUrls,
      }}
    >
      {children}
    </HeaderMenuContext.Provider>
  );
};
